export default __webpack_public_path__ + "static/media/924.28693a12.gif";